import axios from 'axios';

const base = `${process.env.REACT_APP_API_URL}/api/agency`;
const auth = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export async function agencyGet(path, options = {}) {
  return (await axios.get(base + path, { ...options, headers: auth() })).data;
}

// In-memory only. Never persist registration PINs, receipts, or request bodies.
// Unknown network outcomes keep the SAME key when the operator retries.
export function createAgencyWriter() {
  const pending = new Map();
  return async (path, data, method = 'post') => {
    let identity;
    if (data instanceof FormData) {
      const file = data.get('file');
      const hash = await window.crypto.subtle.digest('SHA-256', await file.arrayBuffer());
      identity = `${path}:${Array.from(new Uint8Array(hash), b => b.toString(16).padStart(2, '0')).join('')}`;
    } else {
      identity = `${method}:${path}:${JSON.stringify(data)}`;
    }
    const key = pending.get(identity) || window.crypto.randomUUID();
    pending.set(identity, key);
    try {
      const result = await axios({ url: base + path, method, data,
        headers: { ...auth(), 'Idempotency-Key': key } });
      pending.delete(identity);
      return result.data;
    } catch (error) {
      if (error.response?.status >= 400 && error.response?.status < 500) pending.delete(identity);
      // Do not log axios errors: their config contains the original private payload.
      const safeError = new Error(error.response?.data?.message || 'No se pudo confirmar la operación. Reintenta con los mismos datos antes de crear otra.');
      safeError.status = error.response?.status;
      throw safeError;
    }
  };
}

export const money = cents => new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format((cents || 0) / 100);
export const limaInputTime = () => new Intl.DateTimeFormat('sv-SE', { timeZone: 'America/Lima',
  year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date()).replace(' ', 'T');
export const paidAt = value => `${value}:00-05:00`;
